import {
  Legacyprofile,
  Publicprofile,
  RegularProfileList as RegularProfileListData,
} from '@/payload-types'
import LegacyRegularPostProfileCard from '@/components/legacy-profile-profile-card/regularPostProfileCard'
import { SortProfileListAlphabetically } from '@/lib/profileFunction'
import RegularPostProfileCard from '../public-profile-card/regularPostProfileCard'

interface IProps {
  profileListData: RegularProfileListData | null
}

export const RegularProfileList = ({ profileListData }: IProps) => {
  if (profileListData?.hasManyProfileList) {
    const sortedProdileList = SortProfileListAlphabetically(profileListData)
    return (
      <div className="flex flex-wrap justify-evenly md:block">
        {sortedProdileList?.map((item, index) => {
          if (item.relationTo === 'publicprofiles') {
            return <RegularPostProfileCard profileData={item.value as Publicprofile} key={index} />
          } else {
            return (
              <LegacyRegularPostProfileCard profileData={item.value as Legacyprofile} key={index} />
            )
          }
        })}
      </div>
    )
  }
}

export default RegularProfileList
